"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionType = void 0;
var ActionType;
(function (ActionType) {
    ActionType["Purchase"] = "purchase";
    ActionType["RequestInvite"] = "requestInvite";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
